import React from 'react';
import PropTypes from 'prop-types';
import { QueryParam } from '@bingads-webui-react/scope-service';

// This HOC add storeId as the component key.
// It can make sure React will create a new instance if the storeId was changed.
export const withStoreIdAsKey = (Component) => {
  const WrappedComponent = (props) => {
    const {
      scope: {
        values: {
          storeId,
        },
      },
    } = props;
    return (<Component {...props} key={storeId} />);
  };

  WrappedComponent.propTypes = {
    scope: PropTypes.instanceOf(QueryParam).isRequired,
  };

  return WrappedComponent;
};
